// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext.jsx';

const labels = {
  ru: 'Наверх',
  uz: 'Yuqoriga',
  en: 'Back to top',
};

export function ScrollToTopButton() {
  const { locale } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const offset = document.scrollingElement?.scrollTop || window.pageYOffset || document.documentElement.scrollTop || 0;
      setVisible(offset > 560);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('scroll', update, { passive: true, capture: true });
    return () => {
      window.removeEventListener('scroll', update);
      document.removeEventListener('scroll', update, { capture: true });
    };
  }, []);

  if (!visible) return null;

  const moveToTop = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';
    if (document.scrollingElement?.scrollTo) document.scrollingElement.scrollTo({ top: 0, behavior });
    else window.scrollTo({ top: 0, behavior });
  };

  return <button className="scroll-to-top" type="button" onClick={moveToTop} aria-label={labels[locale] || labels.ru} title={labels[locale] || labels.ru}>
    <ArrowUp aria-hidden="true"/>
    <span>{labels[locale] || labels.ru}</span>
  </button>;
}
